import { useCallback, useEffect, useRef } from 'react';
export function useDebounce(fn, wait) {
  var timerRef = useRef();
  var fnRef = useRef(fn);
  if (fn !== fnRef.current) {
    fnRef.current = fn;
  }
  useEffect(function () {
    return function () {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);
  return useCallback(function () {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    timerRef.current = setTimeout(function () {
      fnRef.current.apply(_this, args);
    }, wait);
  }, [wait]);
}
export default useDebounce;